<template>
  <div class="flex align-middle justify-center">
    <Icono :nombre="icono" />
    <div v-html="mensaje" />
  </div>
</template>

<script>
import Icono from "@/components/Icono";

export default {
  props: ["mensaje", "icono"],
  components: { Icono },
  methods: {
    click() {
      this.$emit("clickeado", this.numero);
    }
  }
};
</script>
